import { PATHWAY } from "@/constants/testIds";
import { JOURNEY } from "@/lib/pathwayData";

export default function Journey() {
  return (
    <section id="journey" className="border-t hairline bg-[#0a0a0a]">
      <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
        <SectionEyebrow>I. Sponsor journey</SectionEyebrow>
        <h2 className="mt-4 max-w-3xl font-serif text-3xl leading-tight tracking-tight text-neutral-50 sm:text-4xl lg:text-5xl">
          Six steps from emerging risk to governed pathway.
        </h2>
        <p className="mt-6 max-w-2xl text-neutral-400">
          The insurance mode of Lab Pathway replaces the generic six-step
          journey with one calibrated to how specialty risks become understood,
          evidenced and moved toward insurability.
        </p>

        <ol className="mt-16 grid grid-cols-1 gap-0 border-t border-l hairline md:grid-cols-2 lg:grid-cols-3">
          {JOURNEY.map((s, i) => (
            <li
              key={s.n}
              data-testid={PATHWAY.journeyStep(i + 1)}
              className="border-b border-r hairline p-8 md:p-10"
            >
              <div className="flex items-baseline gap-4">
                <span className="font-mono text-xs tracking-[0.24em] text-amber-600">
                  {s.n}
                </span>
                <span className="h-px flex-1 bg-white/10" />
              </div>
              <h3 className="mt-5 font-serif text-2xl leading-snug text-neutral-100">
                {s.title}
              </h3>
              <p className="mt-4 text-[15px] leading-relaxed text-neutral-400">
                {s.body}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export function SectionEyebrow({ children }) {
  return (
    <div className="font-mono text-[10px] uppercase tracking-[0.32em] text-amber-600">
      {children}
    </div>
  );
}
